import * as React from 'react';
import styled from 'styled-components';

import { MainMenu } from '@longline/aqua-ui/modules/MainMenu';
import { SVG } from '@longline/aqua-ui/svg';

import { Sprites } from './svg';
import { useGlobalState } from './contexts/state/GlobalStateContext';
import { Can } from './ui/Can';

interface IProps {
  /** @ignore */
  className?: string;
}

const NavBase = (props: IProps) => {
  const globalState = useGlobalState();

  return (
    <div className={props.className}>
      <Logo>
        <use xlinkHref={Sprites.Logos.LogoSymbolWhite}></use>
      </Logo>
      <MainMenuHolder>
        <MainMenu>
          <MainMenu.Item icon={Sprites.Menu.Systems} active={globalState.mode=='systems'} onClick={() => globalState.setMode('systems')}>SYSTEMS</MainMenu.Item>
          <MainMenu.Item icon={Sprites.Menu.Project} active={globalState.mode=='project'} onClick={() => globalState.setMode('project')}>PROJECT</MainMenu.Item>
          <MainMenu.Item icon={Sprites.Icons.Layers} active={globalState.mode=='layers'} onClick={() => globalState.setMode('layers')}>LAYERS</MainMenu.Item>
          <MainMenu.Item icon={Sprites.Icons.Structures} active={globalState.mode=='structures'} onClick={() => globalState.setMode('structures')}>STRUCTURES</MainMenu.Item>
          <MainMenu.Item icon={Sprites.Icons.GeoLayers} active={globalState.mode=='references'} onClick={() => globalState.setMode('references')}>REFERENCES</MainMenu.Item>
          <Can permission="simulate">
            <MainMenu.Item icon={Sprites.Icons.Grid} active={globalState.mode=='areas'} onClick={() => globalState.setMode('areas')}>SIMULATION</MainMenu.Item>
          </Can>
          <Can permission='view_users'>
            <MainMenu.Item secondary icon={Sprites.Menu.Users} active={globalState.mode=='users'} onClick={() => globalState.setMode('users')}>USERS</MainMenu.Item>
          </Can>
          <Can permission='manage_species'>
            <MainMenu.Item secondary icon={Sprites.Menu.Species} active={globalState.mode=='species'} onClick={() => globalState.setMode('species')}>SPECIES</MainMenu.Item>
          </Can>
          <MainMenu.Item secondary icon={SVG.Icons.Info} active={globalState.mode=='info'} onClick={() => globalState.setMode('info')}>INFORMATION</MainMenu.Item>
          <MainMenu.Item secondary icon={Sprites.Menu.Account} active={globalState.mode=='account'} onClick={() => globalState.setMode('account')}>ACCOUNT</MainMenu.Item>
        </MainMenu>
      </MainMenuHolder>
    </div>
  )
}

const Logo = styled.svg`
  position: absolute;
  left: 0;
  top: 0;
  width: 80px;
  height: 80px;
  background: #457298;
  padding: 16px;
  box-sizing: border-box;
`

const MainMenuHolder = styled.div`
  position: absolute;
  left: 0;
  top: 80px;
  width: 80px;
  bottom: 0;
`

const NavStyled = styled(NavBase)`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  z-index: 200; // Stay above Map.
`

const Nav = (props: IProps) => <NavStyled {...props}/>

export { Nav }
